import ScSearchInput from "@/src/components/ui-kit/search-bar";
import ScTabs from "@/src/components/ui-kit/tabs";
import ToolbarCreateButton from "@/src/components/ui-kit/toolbar-create-button";
import React from "react";
import { View } from "react-native";

type IconProps = Readonly<{
	size?: number;
	color?: string;
	className?: string;
}>;

type PageHeaderProps<T extends string> = Readonly<{
	searchText: string;
	onSearchChange: (text: string) => void;
	tabs: readonly T[];
	active: T;
	onTabChange: (tab: T) => void;
	searchPlaceholderKey?: string;
	onActionPress?: () => void;
	actionText?: string;
	actionIcon?: React.ReactElement<IconProps> | null;
	secondTabs?: readonly T[];
}>;

export default function PageHeader<T extends string>({
	searchText,
	onSearchChange,
	tabs,
	active,
	onTabChange,
	searchPlaceholderKey = "LABEL_SEARCH",
	onActionPress,
	actionText,
	actionIcon,
	secondTabs,
}: PageHeaderProps<T>) {
	const hasSecondTabs = secondTabs && secondTabs.length > 0 && active !== undefined && onTabChange;

	return (
		<View className="flex-between md:border md:border-ash-3 md:bg-chalk md:rounded-2xl">
			<View className="flex-row items-center justify-between gap-4 pb-3 md:border-b md:border-ash-3 md:p-4">
				<View className="flex-1 md:flex-none md:w-[50%]">
					<ScSearchInput
						value={searchText}
						onChangeText={onSearchChange}
						placeholderKey={searchPlaceholderKey}
						surface="screen"
						onCreatePress={onActionPress}
					/>
				</View>
				{onActionPress && actionText && (
					<ToolbarCreateButton
						text={actionText}
						onPress={onActionPress}
						hideOnMobile
					/>
				)}
			</View>
			<View className="mt-1 justify-center pb-2 md:mt-4 md:px-4 md:pb-4">
				{hasSecondTabs ? (
					<View className="flex-row items-center justify-between">
						<ScTabs tabs={tabs} active={active} onChange={onTabChange} />
						<ScTabs tabs={secondTabs} active={active} onChange={onTabChange} />
					</View>
				) : (
					<ScTabs tabs={tabs} active={active} onChange={onTabChange} />
				)}
			</View>
		</View>
	);
}
